import React from 'react';
import { packItems } from '../data/content';
export function WhatsInside() {
  return <section id="inside" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-200" data-mp="yvqz38dbhvo5">
      <div className="mx-auto max-w-4xl" data-id="element-201" data-mp="ytwkebsn2zsi">
        <h2 className="text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-202" data-mp="kx117qiobryq">
          <span aria-hidden="true" data-id="element-203" data-mp="ptrgwcqkgljm">📦 </span>Cosa c&apos;è dentro il pacchetto
          SCIENZE PRONTA™?
        </h2>

        <ul className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-204" data-mp="b4bsv4if6u7m">
          {packItems.map(item => <li key={item.title} className="flex flex-col rounded-2xl bg-sand px-6 py-8 text-center" data-id="element-205" data-mp="fz99oxlxy7v2">
              <span className="text-2xl leading-none" aria-hidden="true" data-id="element-206" data-mp="23neg8p46ru7">
                {item.emoji}
              </span>
              <h3 className="mt-4 font-display text-base font-bold text-ink" data-id="element-207" data-mp="3od84hvx6fn6z">
                {item.title}
              </h3>
              <p className="mt-2 text-xs leading-relaxed text-ink/55" data-id="element-208" data-mp="3tcazsoncuf1r">
                {item.text}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}